const CLIENT_REGEXPS = {
  regexRfcPersonaFisica: /^([A-Z,Ñ,&]{4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[A-Z|\d]{3})$/i,
  regexRfcPersonaMoral: /^([A-Z,Ñ,&]{3}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[A-Z|\d]{3})$/i,
  regexPhone: /^[+]?[0-9]{10,15}$/,
  regexZipCode: /^[0-9]{5}$/,
  regexComercialCharge: /^[0-9]{4}$/,
  regexMinLicenses: /^[0-9]{0,10}$/,
  regexClientCode: /^([0-9]{6})$/,
  regexStpClabe: /^[A-Z0-9]{18}$/i
}

const DOMAIN_REGEXP = {
  regexpBussinesSegment: /^[0-9]{3}$/i,
  regexpBillingCode: /^[A-Z0-9]{10}$/i
}

const GENERAL_REGEXPS = {
  email: /^[a-zñA-ZÑ0-9._-]+@[a-zñA-ZÑ0-9.-]+\.[a-zA-Z]{2,4}$/,
  phone: /^([+][0-9]{1,3})?([0-9]{10,11})$/
}

const PASSWORD_REGEXP = {
  low_password: /^.{4,32}$/,
  medium_password: /^.*(?=.{6,32})(?=.*\d)(?=.*[a-zA-Z]).*$/,
  high_password: /^(?=.*[a-zñ])(?=.*[A-ZÑ])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~])([^ ]){8,32}$/
}

const FILLGRID_REGEXPS = {
  SEARCH: {
    USER_OR_ALTUSER: /user:[\w-]+\s*(or|oR|Or|OR)\s*altUser:[\w-]+/g
  }
}

export {
  CLIENT_REGEXPS,
  DOMAIN_REGEXP,
  FILLGRID_REGEXPS,
  GENERAL_REGEXPS,
  PASSWORD_REGEXP
}
